/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PropertyPortalPublication } from '../models/PropertyPortalPublication';
import type { PropertyPortalPublicationActionExecutionResponse } from '../models/PropertyPortalPublicationActionExecutionResponse';
import type { PropertyPortalPublicationCreateBodyParams } from '../models/PropertyPortalPublicationCreateBodyParams';
import type { PropertyPortalPublicationCreateResponse } from '../models/PropertyPortalPublicationCreateResponse';
import type { PropertyPortalPublicationDeleteResponse } from '../models/PropertyPortalPublicationDeleteResponse';
import type { PropertyPortalPublicationDisplayStatusFilter } from '../models/PropertyPortalPublicationDisplayStatusFilter';
import type { PropertyPortalPublicationEnqueuedActionResponse } from '../models/PropertyPortalPublicationEnqueuedActionResponse';
import type { PropertyPortalPublicationListResponse } from '../models/PropertyPortalPublicationListResponse';
import type { PropertyPortalPublicationUpdateBodyParams } from '../models/PropertyPortalPublicationUpdateBodyParams';
import type { PropertyPortalPublicationUpdateResponse } from '../models/PropertyPortalPublicationUpdateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IntegrationsPortalPublicationsService {
    /**
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @param displayStatus Optional provider-aware display-status filter used by list surfaces.
     * @returns PropertyPortalPublicationListResponse Ok
     * @throws ApiError
     */
    public static listPublications(
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
        displayStatus?: PropertyPortalPublicationDisplayStatusFilter,
    ): CancelablePromise<PropertyPortalPublicationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/integrations/portal-publications',
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
                'displayStatus': displayStatus,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns PropertyPortalPublicationCreateResponse Ok
     * @throws ApiError
     */
    public static createPublication(
        requestBody: PropertyPortalPublicationCreateBodyParams,
    ): CancelablePromise<PropertyPortalPublicationCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/portal-publications',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns any Ok
     * @throws ApiError
     */
    public static getPublication(
        id: number,
    ): CancelablePromise<PropertyPortalPublication | null> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/integrations/portal-publications/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns PropertyPortalPublicationUpdateResponse Ok
     * @throws ApiError
     */
    public static updatePublication(
        id: number,
        requestBody: PropertyPortalPublicationUpdateBodyParams,
    ): CancelablePromise<PropertyPortalPublicationUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/integrations/portal-publications/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns PropertyPortalPublicationDeleteResponse Ok
     * @throws ApiError
     */
    public static deletePublication(
        id: number,
    ): CancelablePromise<PropertyPortalPublicationDeleteResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/integrations/portal-publications/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns PropertyPortalPublicationEnqueuedActionResponse Ok
     * @throws ApiError
     */
    public static enqueuePublicationPublish(
        id: number,
    ): CancelablePromise<PropertyPortalPublicationEnqueuedActionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/portal-publications/{id}/actions/publish/enqueue',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns PropertyPortalPublicationEnqueuedActionResponse Ok
     * @throws ApiError
     */
    public static enqueuePublicationPause(
        id: number,
    ): CancelablePromise<PropertyPortalPublicationEnqueuedActionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/portal-publications/{id}/actions/pause/enqueue',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns PropertyPortalPublicationEnqueuedActionResponse Ok
     * @throws ApiError
     */
    public static enqueuePublicationUnpublish(
        id: number,
    ): CancelablePromise<PropertyPortalPublicationEnqueuedActionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/portal-publications/{id}/actions/unpublish/enqueue',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns PropertyPortalPublicationActionExecutionResponse Ok
     * @throws ApiError
     */
    public static executePublicationPause(
        id: number,
    ): CancelablePromise<PropertyPortalPublicationActionExecutionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/portal-publications/{id}/actions/pause',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns PropertyPortalPublicationActionExecutionResponse Ok
     * @throws ApiError
     */
    public static executePublicationUnpublish(
        id: number,
    ): CancelablePromise<PropertyPortalPublicationActionExecutionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/portal-publications/{id}/actions/unpublish',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
